import React from 'react'
import ZocksLogo from '../../assets/images/zocks-logo-black.svg'
import { animationData } from '../../assets/animations/icons8-spinner.json'
import Lottie from 'react-lottie'
import { AuthErrorToast } from './AuthErrorToast'
import './Auth.scss'

export const Redirect: React.FC = () => {
  return (
    <div className='auth-container'>
      <AuthErrorToast />
      <RedirectHeader />
      <div className='auth-popup-container'>
        <div className='auth-popup-inner'>
          <div className='redirect-header' />
          <h2 className='auth-popup-header'>Redirecting in a couple of seconds</h2>
          <RedirectSpinner />
        </div>
      </div>
    </div>
  )
}

const RedirectHeader: React.FC = () => (
  <div className='auth-header'>
    <img className='auth-logo' src={ZocksLogo} alt='Zocks logo' />
    <div className='auth-header-text d-none'>Can't you wait?</div>
    <div className='auth-header-link'>
      <a href='https://www.zocks.io/#schedule-demo' target='_blank' rel='noreferrer'>
        Schedule a demo
      </a>
    </div>
  </div>
)

const RedirectSpinner: React.FC = () => {
  const options = {
    loop: true,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice',
    },
  }

  return <Lottie options={options} width={40} height={40} isClickToPauseDisabled={true} />
}
